export enum VisualTagsEnum {
  PLOT_CONTEXT = 'plot_context',
  ACCESSIBILITY = 'accessibility',
  SOCIAL_ISSUES = 'social_issues',
  MENTAL_HEALTH = 'mental_health',
  DISTURBING_CONTENT = 'disturbing_content',
  LANGUAGE = 'language_flags',
  SUBSTANCE_USE = 'substance_use',
  SEXUAL = 'sexual_content',
  VIOLENCE = 'violence',
}